import axios from 'axios'

export default async function banUser(id: number) {
  await axios.get(`/api/v1/user/ban/${id}`)
}
